import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Redirect } from 'react-router-dom';

import { resetPassword } from 'src/services/user.service';
import { postLogoutRoute, resetPasswordOtpRoute } from 'src/routing/routes';
import {
  FloatingInput,
  ShapesDecorativeBorder,
  ButtonPrimary,
  ButtonSecondary,
} from 'src/components';
import TealiumEvents from 'src/helpers/tealium-events';
import { SelfServiceFormBackground } from '../../self-service-form-background/self-service-form-background';
import { MiniAppFocusWrapper } from 'src/components/miniapp-focus-wrapper/miniapp-focus-wrapper';
import { FormContainer } from '../../form-container/form-container';
import toastMessageServiceSingleton from 'src/services/toast-message.service';
import './forgot-password-resend-otp.scss';

export default function ForgotPasswordResendOtp() {
  const [redirectToRoute, setRedirectToRoute] = useState('');

  useEffect(() => {
    TealiumEvents.loginResendOTPPageLoadNewStyle();
  }, []);

  if (!!redirectToRoute) {
    return <Redirect to={redirectToRoute} />;
  }

  const formContent = () => {
    return (
      <Formik initialValues={{ merchantId: '' }} onSubmit={submitResetRequest}>
        {({ isSubmitting, values }) => (
          <FormContainer>
            <Form>
              <div className="has-text-centered">
                <h1 className="form-heading heading-four">Resend OTP</h1>
              </div>
              <Field
                name="merchantId"
                type="text"
                placeholder="Merchant ID"
                component={MiniAppFocusWrapper}
                innerComponent={FloatingInput}
                fieldType="standard"
                className="top-field"
                spacing="has-margin-top-5"
                automationIdPrefix="Reset_Password_Input_MerchantID"
                subtext="Please note you‘ll recieve an SMS with an OTP pin."
                autoFocus
              />

              <ButtonPrimary
                disabled={isSubmitting || !isFormValid(values)}
                className="reset-button"
                automationid="Reset_Password_Button_Request_Reset"
              >
                Resend
              </ButtonPrimary>

              <ButtonSecondary
                disabled={isSubmitting}
                className="cancel-button"
                automationid="Reset_Password_Button_Back"
                onClick={() => {
                  setRedirectToRoute(postLogoutRoute);
                }}
              >
                Cancel
              </ButtonSecondary>
            </Form>
          </FormContainer>
        )}
      </Formik>
    );
  };

  return (
    <div className="forgot-password-resend-otp">
      <SelfServiceFormBackground>
        <ShapesDecorativeBorder>{formContent()}</ShapesDecorativeBorder>
      </SelfServiceFormBackground>
    </div>
  );

  function isFormValid(values) {
    return !!values.merchantId;
  }

  async function submitResetRequest(values, helpers) {
    const abortController = new AbortController();
    const { setSubmitting, resetForm } = helpers;
    const { error } = await resetPassword(values.merchantId, abortController, true, false);
    if (!abortController.signal.aborted) {
      setSubmitting(false);

      switch (error) {
        case null:
        case undefined:
          TealiumEvents.loginResendOTPClickResend(resetPasswordOtpRoute);
          setRedirectToRoute(resetPasswordOtpRoute);
          break;
        default:
          /* TODO: update backend to send non-generic error when merchant id invalid
             then we can show technical error screen for all other errors. Until
             then we can only assume the error means the merchant id is invalid */
          TealiumEvents.onHandledErrorEventSelfService('merchant id is invalid');
          toastMessageServiceSingleton.addError(
            'Merchant ID is invalid',
            null,
            '401',
            true,
            null,
            true,
          );
          resetForm();
      }
    }
  }
}
